import { render, staticRenderFns } from "./refresh-init.vue?vue&type=template&id=e4ac356a&scoped=true"
import script from "./refresh-init.vue?vue&type=script&lang=js"
export * from "./refresh-init.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ac356a",
  null
  
)

export default component.exports